import { FC } from 'react';

import BusinessButton from '../../business-button/business-button';
import { COLORS } from '../../business-button/business-button.constants';
import styles from './card-lifecycle.module.scss';

export interface CardLifecycleProps {
    image?: string;
    title?: string;
    description?: string;
    backgroundContent?: string;
    buttonText?: string;
    buttonLink?: string;
    tileClickable?: boolean;
}

const CardLifecycle: FC<CardLifecycleProps> = (props) => {
    const { image, title, description, backgroundContent, buttonText, buttonLink, tileClickable } = props;

    return (
        <div className={styles.container}>
            {tileClickable && buttonLink ?
                <a className={styles.link} target='_blank' href={buttonLink} />
                : null
            }
            <div className={styles.image}>
                <img src={image} alt="" />
            </div>

            <div
                className={styles.wrapperContent}
                style={{
                    backgroundColor: backgroundContent,
                }}
            >
                <p
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                        __html: title ?? '',
                    }}
                ></p>

                <p
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                        __html: description ?? '',
                    }}
                ></p>

                {buttonText && (
                    <div className={styles.button}>
                        <BusinessButton buttonText={buttonText || 'Learn more'} link={buttonLink || ''} color={COLORS.BLACK}></BusinessButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardLifecycle;
